import Container from "@/components/Container/Container.tsx";
import { LanguagePicker } from "@/components/Inputs/LanguagePicker/LanguagePicker.tsx";
import { Logo } from "@/components/Logo/Logo.tsx";

export const Header = () => {
  return (
    <header className="bookingEngineHeader o-booking-engine__header">
      <Container>
        <div className="o-booking-engine__inner">
          <div className="o-booking-engine__logo">
            <Logo />
          </div>
          <div className="o-booking-engine__language-picker">
            <LanguagePicker />
          </div>
        </div>
      </Container>
    </header>
  );
};
